<template>
  <div class="app-container">
    <div class="filter-container">
      
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="开始时间"
        endPlaceholder="截止时间"
      />
     
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <JsonExcel
        :data="list"
        style="margin-left: 10px"
        :fields="fields"
        name="经营明细表.xls"
      >
        <el-button
          class="filter-item"
          icon="el-icon-download"
          >导出</el-button
        >
      </JsonExcel>
      <JsonExcel
        :data="list"
        style="margin-left: 10px"
        :fields="fields"
        name="经营明细表.xls"
        :fetch="onFetch"
      >
        <el-button
          class="filter-item"
          icon="el-icon-download"
          >全部导出</el-button
        >
      </JsonExcel>
    </div>
    <div class="top-view">
      <div class="top-box" v-for="(item,index) in topList" :key="index">
        <span style="font-size:18px;color:#333">{{item.value}}</span>
        <span style="font-size:18px;color:#333">{{item.text}}</span>
      </div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="salesDate"
        label="日期"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="dailySales"
        label="销售额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="dailyCost"
        label="采购成本"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="dividendAmount"
        label="分润金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="postagesAmount"
        label="运费"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="channelCost"
        label="渠道费用"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="luckyDrawCash"
        label="抽奖现金"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="voucher"
        label="抽奖兑换券"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="refundAmount"
        label="退款金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="grossProfit"
        label="毛利"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getOperatingSummary,
  getOperatingDetails,
} from "@/api/operation";
import DataPicker from "@/views/components/dataPicker.vue";
import JsonExcel from "vue-json-excel";

export default {
  
  components: { DataPicker,JsonExcel },
  filters: {},
  data() {
    return {
      topList:[
        {text:'销售额',value:''},
        {text:'采购成本',value:''},
        {text:'分润金额',value:''},
        {text:'运费',value:''},
        {text:'渠道费用',value:''},
        {text:'抽奖现金',value:''},
        {text:'抽奖兑换券',value:''},
        {text:'退款金额',value:''},
        {text:'毛利',value:''},
      ],
      fields:{
        '日期':'salesDate',
        '销售额':'dailySales',
        '采购成本':'dailyCost',
        '分润金额':'dividendAmount',
        '运费':'postagesAmount',
        '渠道费用':'channelCost',
        '抽奖现金':'luckyDrawCash',
        '抽奖兑换券':'voucher',
        '退款金额':'refundAmount',
        '毛利':'grossProfit',
      },
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        startTime: null,
        endTime: null,
      },
    };
  },
  created() {

    // this.getShippingCompany();
    this.operatingSummary();
    this.getList();
  },
  methods: {
    operatingSummary(){
      
      const form = this.listQuery;
      let params = {
        
      }
      if(form.startTime){
        params['startTime'] = form.startTime;
        params['endTime'] = form.endTime;

      }
      
      getOperatingSummary(params).then(res=>{
          if (res && res.bizcode === 100) {
            const {totalSales,totalDailyCost,totalPostagesAmount,totalDividendAmount,totalChannelCost,
              totalLuckyDrawCash,totalVoucher,totalRefundAmount,totalGrossProfit
            } = res.data;
                this.topList[0].value = totalSales;
                this.topList[1].value = totalDailyCost;
                this.topList[2].value = totalDividendAmount;
                this.topList[3].value = totalPostagesAmount;
                this.topList[4].value = totalChannelCost;
                this.topList[5].value = totalLuckyDrawCash;
                this.topList[6].value = totalVoucher;
                this.topList[7].value = totalRefundAmount;
                this.topList[8].value = totalGrossProfit;

          }
        })
   
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.operatingSummary();
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form,
      };
      getOperatingDetails(params)
        .then((response) => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    async onFetch() {
      let arrData = [];
      let params = {
          page: 1,
        pageSize: 10000,
      }
      const form = this.listQuery;
      if(form.startTime){
        params['startTime'] = form.startTime;
        params['endTime'] = form.endTime;

      }
      let res = await getOperatingDetails(params);
      if(res.data.entitys && res.data.entitys.length){
        arrData = res.data.entitys;
      }else{
        arrData = [];
      }
      return arrData;
      
    },
    // 发货 end
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
        this.listQuery.startTime = value[0];
        this.listQuery.endTime = value[1];
    },
  },
};
</script>
<style scoped lang="scss">
.top-view{
  width:100%;
  display: flex;
  flex-wrap: wrap;
  .top-box{
    width:120px;
    height:100px;
    min-height:100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    box-sizing: border-box;
    border-radius: 8px;
    margin-right:20px;
    margin-bottom:20px;
    border:1px solid #eee;
  }
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
